module.exports = "https://static.cdns.space/tarot-temp/img/temperance.83d5b0da.webp";